import React, { useEffect, useState } from 'react';
import BracketContestantsView from './BracketSeedContestants.view';
import NewGameState from '../../../_types/NewGameState';
import { useGetUserInformationQuery } from '../../../../../../store/api/GraphQlQuery';
import getContestants from '../../../../games-helpers/getContestants';
import { LOG } from '../../../../../../common/Utilities';
import Contestant from '../../../../_types/Contestant';

interface Props {
  newGameState: NewGameState;
  onChangeNewGameState: (newGameState: NewGameState) => void;
}

const BracketContestantsContainer: React.FC<Props> = ({
  newGameState,
  onChangeNewGameState,
}) => {
  const { data: userData, isLoading } = useGetUserInformationQuery({});
  const [contestants, setContestants] = useState<Contestant[]>([]);

  // For GG-1119: selectedContestants should be the non-empty string elements of the competitors array
  const selectedContestants =
    newGameState.competitors?.filter((contestant) => contestant !== '') || [];

  // Check if we have the necessary bracket configuration
  const hasBracketSetup =
    newGameState.bracket && newGameState.bracket.totalCompetitors > 0;

  useEffect(() => {
    const fetchContestants = async () => {
      if (isLoading || !userData) {
        return;
      }

      try {
        const contestants = await getContestants({
          newGameState,
          me: userData.me,
        });
        setContestants(contestants);
      } catch (error) {
        LOG.error(error);
      }
    };

    fetchContestants();
  }, [newGameState.scope, isLoading, userData]);

  // Add console logs for debugging
  console.log(
    'Bracket component - totalCompetitors:',
    newGameState.bracket?.totalCompetitors
  );
  console.log(
    'Bracket component - competitors array:',
    newGameState.competitors
  );
  console.log('Bracket component - selectedContestants:', selectedContestants);
  console.log('Bracket component - hasBracketSetup:', hasBracketSetup);

  if (isLoading || !userData) {
    return null;
  }

  // Only render if we have totalCompetitors set
  if (!hasBracketSetup) {
    console.log('Not rendering BracketContestants - missing bracket setup');
    return null;
  }

  return (
    <BracketContestantsView
      contestants={contestants}
      selectedContestants={selectedContestants}
      newGameState={newGameState}
      onChangeNewGameState={onChangeNewGameState}
    />
  );
};

export default BracketContestantsContainer;
